import './global.less';
import './content.less';
import './ui/index.less';
import 'vueCommon/index.less';
import './fontface.less';

import {
    globalState,
    eventsSender,
    eventBus,
    eventsSenderYandex,
} from 'globalState/global-state.js';

require('./head/head');
require('./content/content');
require('./footer/footer');

globalState.retailMedia.init();

$(function () {
    $('.fancy-short').fancybox({
        afterClose: function () {
            if ($(this).data('amplitude-close')) {
                eventsSender('checkout', $(this).data('amplitude-close'), null);
            }
        },
    });
});

eventBus.handleDeprecatedOpenModal.subscribe(({ url, maxWidth = 480 }) => {
    $.fancybox.open({
        href: url,
        type: 'ajax',
        width: 'auto',
        maxWidth: `${maxWidth}px`,
        maxHeight: '800px',
        beforeShow: function () {
            $('body').addClass('no-scroll');
        },
        afterShow: function () {
            setTimeout(function () {
                $.fancybox.update();
            }, 100);
        },
        afterClose: function () {
            $('body').removeClass('no-scroll');
        },
    });
});

$(document).on(
    'click',
    '.probable-price, .probable-price-alt',
    function (event) {
        event.preventDefault();
        openProbableModal('/clubAutorization/?back_url=' + location.pathname); // eslint-disable-line
    }
);

if ($('#menuLK').length) {
    var headers = new Headers();
    headers.append('Accept', 'application/json, text/javascript, */*; q=0.01');
    fetch('/countItems/?model=RequestByVin', { headers: headers })
        .then((res) => res.json())
        .then((json) => {
            if (json.success) {
                $('.counter-vin a').append(
                    `<strong class="message-count">(${json.result})</strong>`
                );
            }
        });

    fetch('/countItems/?model=RtHistory', { headers: headers })
        .then((res) => res.json())
        .then((json) => {
            if (json.success) {
                $('.counter-problem a').append(
                    `<strong class="message-count">(${json.result})</strong>`
                );
            }
        });
}

globalState.clearStorage();

$(document).on('click', '.link-to', function (event) {
    event.preventDefault();
    location.assign($(this).data('link'));
});

$(document).on('click', '.fancy-modal', function (event) {
    event.preventDefault();
    $.fancybox.open({
        href: $(this).data('link'),
        type: 'iframe',
        width: '800px',
        height: '800px',
    });
});

$(document).on('click', '.fancy-ajax', function (event) {
    event.preventDefault();
    $.fancybox.open({
        href: $(this).data('link'),
        type: 'ajax',
        width: '800px',
        height: '800px',
    });
});

$(document).on('click', '.probable-price-waiting', function (event) {
    event.preventDefault();
    eventBus.handleDeprecatedOpenModal.broadcast({
        url: `/priceWaitingPopup/?discountPercent=${$(this).data('percent')}`,
    });
});

/** Для Notification /personal/notifications/ */
$('.unsubscribe-all').click(function (e) {
    e.preventDefault();
    $('.notifications-form input').prop('checked', false);
    $('.notifications-save').click();
});

$('.subscribe-all').click(function (e) {
    e.preventDefault();
    $('.notifications-form input').prop('checked', true);
    $('.notifications-save').click();
});

$(document).on('click', '.close-fancybox', function () {
    $.fancybox.close();
});

if (location.search.includes('utm_source=sberid')) {
    eventsSenderYandex('login', 'loginBySberIDSuccess', {
        source: location.pathname,
    }).then(() => {
        const url = new URL(window.location);
        url.searchParams.delete('utm_source');
        history.replaceState(null, '', url);
    });
}

if (location.search.includes('utm_source=sbol')) {
    eventsSenderYandex('login', 'loginBySBOLSuccess', {
        source: location.pathname,
    }).then(() => {
        const url = new URL(window.location);
        url.searchParams.delete('utm_source');
        history.replaceState(null, '', url);
    });
}
